module.exports = __webpack_public_path__ + "media/components/web/pages/static_pages/resources/not_found_image-b25429dfbee6475e4d6f00e7b20ea1c3.svg";